import { PitchCropOptions } from '../visualisations/PitchVisualisation/PitchCropOptions';
import { PitchMarkerColouring } from '../visualisations/PitchVisualisation/PitchMarkerColouring';
import { PitchMarkerPlacementToggle } from '../visualisations/PitchVisualisation/PitchMarkerPlacementToggle';
import { PitchMarkerToggle } from '../visualisations/PitchVisualisation/PitchMarkerToggle';
import { PitchOrientationToggle } from '../visualisations/PitchVisualisation/PitchOrientationToggle';
import { SettingsPanel } from './SettingsPanel';

export const PitchVisSettingsPanel = () => (
  <SettingsPanel>
    <PitchMarkerToggle />
    <PitchMarkerColouring />
    <PitchMarkerPlacementToggle />
    <PitchOrientationToggle />
    <PitchCropOptions />
  </SettingsPanel>
);
